'use strict';

var base = require('./base');
var utils = require('../utils');
const events = require('../util/events');
const boldmetrics = require('../product/boldmetrics');

// Class Selectors
const detailTitleClass = '.detail-title';
const jsAccordionPdpClass = '.js-accordion-pdp';
const jsUpsBopisClass = '.js-ups-bopis';
const collapsibleLgClass = '.collapsible-lg';
const copyLinkMessageClass = '.copy-link-message';
const infoListClass = '.info-list';

module.exports = {
    availability: window.sitePrefs.bopisEnabled ? require('./bopisDetail') : base.availability,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length || $('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
            if (response.data.pickUpInStore && response.data.pickUpInStore.defaultShippingMethod) {
                var defaultShippingMethod = response.data.pickUpInStore.defaultShippingMethod;
                if (defaultShippingMethod.freeShippingMessage) {
                    response.container.find('.product-default-shipping-method').text(defaultShippingMethod.freeShippingMessage);
                } else {
                    response.container.find('.product-default-shipping-method').text(defaultShippingMethod.shipToHomeMessage);
                }
                response.container.find('.product-estimated-arrival-time').text(defaultShippingMethod.estimatedArrivalTime);
            }
            if ((response.data.preOrderData && response.data.preOrderData.hasPreOrder) || (response.data.backOrderData && response.data.backOrderData.hasBackOrder)) {
                response.container.find('button.add-to-cart').prop('disabled', true);
                response.container.find('.preorder-qty-msg').removeClass('d-none');
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            var preOrderFlag = response.product.availability.preOrder;
            var backorderFlag = response.product.availability.backorder;
            if (preOrderFlag !== undefined && preOrderFlag) {
                $('.cart-and-ipay .button-label').text(response.product.availability.preOrderMsg);
                $('.add-to-cart-sticky .sales').text(response.product.availability.preOrderMsg);
                $('.cart-and-ipay .add-to-cart').attr('data-preorder', 'true');
            } else if (backorderFlag !== undefined && backorderFlag) {
                $('.cart-and-ipay .button-label').text(response.product.availability.backorderMsg);
                $('.add-to-cart-sticky .sales').text(response.product.availability.backorderMsg);
                $('.cart-and-ipay .add-to-cart').attr('data-backorder', 'true');
            } else {
                $('.cart-and-ipay .button-label').text(response.product.availability.isInstockMsg);
                $('.add-to-cart-sticky .sales').text(response.product.availability.isInstockMsg);
                $('.cart-and-ipay .add-to-cart').attr('data-preorder', 'false');
            }

            // disable add to cart button if product is not available or unorderable
            const disableAddToCart = response.product ? !response.product.available || response.product.hasSelectedUnorderableVariant : false;
            $('button.add-to-cart-global').attr('disabled', disableAddToCart);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            var inStockMsg = $('[data-instock-msg]').data('instock-msg');
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            if (inStockMsg && response.message.indexOf(inStockMsg) > -1) {
                $('.availability-msg', response.$productContainer).empty();
            } else {
                $('.availability-msg', response.$productContainer)
                    .empty().html(response.message).show();
            }

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            // Remove timeout after CCT-4727 is done.
            setTimeout(() => {
                $('#unique-id-size-chart').modal('show');
            }, 5);
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function (event) {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $(copyLinkMessageClass).attr('role', 'alert');
            $(copyLinkMessageClass).removeClass('d-none');
            setTimeout(function () {
                $(copyLinkMessageClass).addClass('d-none');
            }, 3000);
        });
    },
    shownAccordion: function () {
        $(detailTitleClass).parents(collapsibleLgClass).find('.collapse').on('shown.bs.collapse', function () {
            $(this).parent().find('.detail-title .plus').addClass('d-none');
            $(this).parent().find('.detail-title .minus').removeClass('d-none');
            $('.product-detail .collapsible-lg').not($(this).parents(collapsibleLgClass)).find('.collapse.show').collapse('hide');
            base.stickyProductDescription();
        });
        $(jsAccordionPdpClass).siblings(jsUpsBopisClass).on('shown.bs.collapse', function () {
            $(jsAccordionPdpClass).not($(this).siblings(jsAccordionPdpClass)).siblings(jsUpsBopisClass).collapse('hide');
        });
    },
    hiddenAccordion: function () {
        $(detailTitleClass).parents(collapsibleLgClass).find('.collapse').on('hidden.bs.collapse', function () {
            $(this).parent().find('.detail-title .minus').addClass('d-none');
            $(this).parent().find('.detail-title .plus').removeClass('d-none');
            base.stickyProductDescription();
        });
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    initLocally: function () {
        var container = $('.locally').closest('.product-details').not('.bisn-modal');
        base.initLocally(container);
    },

    initShoeFinder: function () {
        if (!window.openShoeFinder) {
            window.openShoeFinder = () => {
                // start the spinner
                $.spinner().start();
                // get the shoe finder url
                var shoeFinderURL = utils.appendToUrl(window.sitePrefs.urls.shoeFinder, { format: 'ajax' });
                // iframe markup
                var $iframe = $('<iframe>', { class: 'shoe-finder-iframe' })
                    .attr('src', shoeFinderURL);
                // modal markup
                var $shoeFinderModal = $(`
                    <div class="modal fade nb-modal shoe-finder-modal">
                        <div class="modal-dialog">
                            <div class="modal-content container">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span>
                                            <svg role="img" class="icon svg-icon" width="16" height="16" aria-label="title">
                                                <title>icon</title>
                                                <desc>icon</desc>
                                                <use xlink:href="#close-icon"></use>
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                                <div class="modal-body"></div>
                            </div>
                        </div>
                    </div>
                `);
                // append iframe to modal body
                $shoeFinderModal.find('.modal-body').append($iframe);
                // on load, hide the spinner
                $iframe.on('load', function () {
                    // $shoeFinderModal.show();
                    $shoeFinderModal.modal('show');

                    $.spinner().stop();
                });
                // append to body
                $('body').append($shoeFinderModal);
            };
        }
    },

    initTracking() {
        $(document).on('click', (event) => {
            const delayClick = Boolean(
                event.target.closest('#bisn-modal-trigger, .add-to-cart, [data-attr="style-value"], [data-attr="size-value"], [data-attr="width-value"], [data-attr="cup-value"]')
            );
            // Extra timeout for some Tealium-GetWishlistProduct calls.
            // Other calls - like Cart-AddProduct and Product-Variation - take precedence.
            const timeout = delayClick ? 50 : events.DEFAULT_DELAY;
            events.triggerEventDelayed(event.target, events.TRACKING_PRODUCTDETAIL, null, timeout);
        });
    },

    toolTip: function () {
        const containerClass = '.t-tip-container';
        $(document).on('touchstart', containerClass, function (event) {
            var elem = $(event.currentTarget);
            elem.find('.t-tip').toggleClass('d-flex');
        });

        $(document).on('mouseenter', containerClass, function (event) {
            var elem = $(event.currentTarget);
            elem.find('.t-tip').addClass('d-flex');
        });

        $(document).on('mouseleave', containerClass, function (event) {
            var elem = $(event.currentTarget);
            elem.find('.t-tip').removeClass('d-flex');
        });
    }
};

/**
 * Get product set with url.
 * @param {Array} el - representing the clicked object.
 * @return {Object} elToReturn - URL to consider for updating the attributes.
 */
function getUrlForAttributeUpdate(el) {
    var elToReturn;
    el.each(function (idx, element) {
        if (element.dataset.url !== 'null') {
            elToReturn = element;
            return false;
        }
        return true;
    });
    return elToReturn;
}

/**
 * Add class to carousel li if video included.
 */
function videoCarouselIndicators() {
    var $carouselContainer = $('#pdpCarousel');
    var $carousel = $carouselContainer.find('.carousel-indicators');
    if ($('div.carousel-video').length) {
        $($($carousel).find('li:nth-child(3)')).first().addClass('video');
    }
}

/**
 * Check if url has hash values to load.
 */
function loadAttributesFromHashValuesParams() {
    // Logic to check if URL consists of Variations attributes to be selected. SFRA-1179
    var productElement = $('[data-attr="style-value"], [data-attr="size-value"], [data-attr="width-value"], [data-attr="cup-value"]');
    var hashArr = window.location.hash.substring(1);
    var el = getUrlForAttributeUpdate(productElement);
    if (hashArr.length) {
        var urlToAppend = new URL(el.dataset.url);
        urlToAppend.search = '?' + hashArr;
        var $productContainer = $(productElement).closest('.set-item').length ? $(productElement).closest('.set-item')
            : $(productElement).closest('.product-detail');
        base.attributeSelect(urlToAppend.href, $productContainer, true);
    } else {
        $(document).trigger('product:initialattrselect');
    }
}

/**
 * Toggle Product Availability View
 */
function toggleProductAvailability() {
    var $addToCartButton = $('.prices-add-to-cart-actions .add-to-cart');
    if ($addToCartButton.length) {
        var isProductNotAvailable = $addToCartButton.hasClass('d-none');
        if (!isProductNotAvailable) {
            base.toggleAvailabilityMessage();
        }
    }

    // hide add to cart or notify as per cart-and-ipay section
    var $cartPay = $('.cart-and-ipay');
    var $stickyCart = $('.add-to-cart-sticky');
    if ($cartPay.find('.notify-cart').hasClass('d-none')) {
        $stickyCart.find('.notify-cart').addClass('d-none');
    }
    if ($cartPay.find('.add-to-cart').hasClass('d-none')) {
        $stickyCart.find('.add-to-cart').addClass('d-none');
    }
}

/**
 * model size details html
 * @param {jquery} modelContainer - modal html of size details
 * @param {array} sizeArray - modal html of size details
 */
function modelSizeList(modelContainer, sizeArray) {
    var modelString;
    var sizeList;
    for (var i = 0; i < sizeArray.length; i += 1) {
        modelString = sizeArray[i].split(/[., ]{2,}/);
        $(modelContainer).append('<div class="info-list multiple"><ul></ul></div>');
        if (modelContainer.find(infoListClass).length === 2) {
            for (var j = 0; j < modelString.length; j += 1) {
                sizeList = '<li>' + modelString[j] + '</li>';
                modelContainer.find('.info-list:nth-child(2) ul').append(sizeList);
            }
            $('<span class="vertical-line"></span>').insertAfter($(modelContainer).find(infoListClass).first());
        } else {
            for (var k = 0; k < modelString.length; k += 1) {
                sizeList = '<li>' + modelString[k] + '</li>';
                modelContainer.find('.info-list ul').append(sizeList);
            }
        }
    }
}

/**
 * model info details formatted
 * @param {jquery} container - modal container
 */
function modelInfoDetails(container) {
    var modelInfoText = container.html();
    var modelInfoArray;
    if (modelInfoText.length) {
        if (modelInfoText.includes('|')) {
            container.empty();
            modelInfoArray = modelInfoText.split(/[|]/);
            modelSizeList(container, modelInfoArray);
        } else if (!container.find(infoListClass).children('ul').length) {
            modelInfoArray = modelInfoText.split(/[., ]{2,}/);
            container.empty().append('<div class="info-list"><ul></ul></div>');
            var modelData;
            modelInfoArray.forEach(function (data) {
                modelData = data.trim();
                var modelTextInfo = '<li>'
                    + modelData
                    + '</li>';
                container.find('.info-list ul').append(modelTextInfo);
            });
        }
    }
}

/**
 * hide/show model info modal
 */
function toggleModelInfo() {
    let modelContainer;
    $('body').on('click mouseover', '.model-info-btn', function (e) {
        e.preventDefault();
        modelContainer = $(this).siblings('.model-content').find('.model-info');
        modelInfoDetails(modelContainer);
        $(this).next('.model-content').removeClass('d-none');
        $(this).addClass('d-none');
    });
    $('body').on('click', '.model-close-btn', function (e) {
        e.preventDefault();
        $(this).parents('.model-content').addClass('d-none');
        $(this).parents('.model-info-wrapper').find('.model-info-btn').removeClass('d-none');
    });
    $('body').on('mouseleave', '.model-content', function (e) {
        e.preventDefault();
        $(this).addClass('d-none');
        $(this).parent().find('.model-info-btn').removeClass('d-none');
    });
}

/**
 * Hide width selection when only one is available, and it's standard width
 */
function hideSingleWidth() {
    var $attributeWrapper = $('#productAtributes');
    var gender = $attributeWrapper.data('product-gender');
    if (!gender) {
        return;
    }

    var $widthWrapper = $attributeWrapper.find(".dyanamic-attr[data-attr='width']");
    var $widths = $widthWrapper.find('.width-attribute');
    var showSingleWidthAttribute = window.sitePrefs.showSingleWidthAttribute;
    // D is standard width for men's shoes, B is standard for women's
    if ($widths.length === 1 && !showSingleWidthAttribute
        && (((gender.startsWith('M') || gender.startsWith('U')) && $widths.data('attrvalue') === 'D')
            || (gender.startsWith('W') && $widths.data('attrvalue') === 'B')
            || (gender.startsWith('K') && $widths.data('attrvalue') === 'M'))) {
        $widthWrapper.hide();
    }
}

$(document).ready(function () {
    hideSingleWidth();
    $('.availability-msg:not(:has(li))').hide();
    base.stickyProductDescription();
    $(window).resize(base.stickyProductDescription);
    loadAttributesFromHashValuesParams();
    toggleProductAvailability();
    videoCarouselIndicators();
    base.displayFitConversion();
    toggleModelInfo();
    boldmetrics.init();
});
